import { removeScripts } from 'common-utils';

import { Events } from '../tracking-events/event';
import { TrackingTool } from '../tracking-tool';
import { TrackingProperties } from '../use-tracking';

declare global {
  interface Window {
    gtag: (
      type: 'event',
      action: string,
      config: { [key: string]: number | string | boolean | null | undefined },
    ) => void;
  }
}

if (typeof window !== undefined) {
  try {
    // eslint-disable-next-line
    (window as any).product = process.env.NEXT_PUBLIC_PRODUCT;
  } catch (err) {}
}

const discoveryPublisherAllowedEvents = [
  // Discovery Publisher
  'Click to Track - Discovery B2B',
  'Click to track',
  'Publisher Dashboard Section Viewed',
  'Input Intent',
];

const allowedDiscoveryEventTypes = [
  'Click to track',
  'Visibility',
  'Navigation Used',
  'GetFTR institute selected',
  'Feedback success',
  'click to track',
  'User Details',
  'UnBookmark',
  'UnBookmark Failed',
  'Tag Click',
  'Tag click',
  'Share Success',
  'Share Intent',
  'Institute selected and saved',
  'Feedback Success',
  'feedback',
  'Click to Track',
  'Click to track - R Life',
  'Click to track - Discovery',
  'Auto sync not available',
  'Article rank in search',
  'Input intent',
  'Input focused',
  'Translation Success',
  'Translation Error',
  'Translate Intent',
  'Language Selection',
  'delete-article',
  'New Note Created',
  'Intent_to_view_Highlights_Summary',
  'Goal tracking',
  'paperpal-citation',
  'create-save',
];
const allowedEventTypes = [
  'Page Viewed',
  'sign-up',
  'login-in',
  'change-password',
  'file-upload',
  'file-upload-failed',
  'payment',
  'login-in-failed',
  'change-password-intent',
  'change-password-failed',
  'login-in-intent',
  'sign-up-failed',
  'sign-up-intent',
  'click-to-track-paperpal',
  'view-to-track-paperpal',
  'PP-first-time-use',
  'search_paperpal',
  'captcha',
  'manuscript_upload',
  'payment-success-page-viewed',
  'PP-LS-first-time-use',
  'paywall_hit',
  ...discoveryPublisherAllowedEvents,
  ...allowedDiscoveryEventTypes,
];

export class GoogleTagManager implements TrackingTool {
  private readonly _gtmId: string;
  private baseURL: string;

  constructor(gtmId: string, enableGtgForGtm = 'false') {
    this._gtmId = gtmId;
    this.baseURL =
      enableGtgForGtm === 'true'
        ? `/metrics/${gtmId}`
        : `https://www.googletagmanager.com/gtm.js`;
  }

  async trackCommonEvent(event: Events, properties?: TrackingProperties) {
    if (properties?.disableGa4Tracking) {
      return;
    }
    // if (event.type === 'sign-up') {
    //   //@ts-ignore
    //   window.dataLayer.push({ event: 'sign_up' });
    // }
    // if (event.type === 'sign-in') {
    //   //@ts-ignore
    //   window.dataLayer.push({ event: 'login' });
    // }
    // Check if the event type is in the allowed list
    if (allowedEventTypes.includes(event.type)) {
      if (event.type === 'sign-up') {
        console.info(
          `Event sent to GTM | ${event.type} | ${localStorage.getItem(
            'ssoUserId',
          )}`,
        );
      }

      const { type, ...eventDataRaw } = event;

      const mergedData = {
        ...eventDataRaw,
        ...properties,
      };
      delete mergedData?.disableGa4Tracking;

      const eventData = {
        ...mergedData,
        trackingName:
          'trackingName' in mergedData ? mergedData.trackingName ?? '' : '',
        elementName:
          'elementName' in mergedData ? mergedData.elementName ?? '' : '',
        intent: 'intent' in mergedData ? mergedData.intent ?? '' : '',
      };
      const dataLayerObject = {
        event: type,
        ...eventData,
      };
      //@ts-ignore
      window.dataLayer.push(dataLayerObject);
    }
  }

  public turnOn = async () => {
    console.info('GTM loaded');
    startGTM(this._gtmId, this.baseURL);
    addGTMNoScript(this._gtmId, this.baseURL);
  };

  public turnOff = async () => {
    console.info('GTM removed');
    removeScripts([`${this.baseURL}?id=${this._gtmId}}`]);
  };
  public getName = () => {
    return 'google-tag-manager';
  };
  public trackEvent = async () => {};
}

function startGTM(gtmId: string, baseURL: string) {
  //@ts-ignore
  (function (w, d, s, l, i) {
    //@ts-ignore
    w[l] = w[l] || [];
    //@ts-ignore
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    //@ts-ignore
    const f = d.getElementsByTagName(s)[0],
      //@ts-ignore
      j = d.createElement(s),
      //@ts-ignore
      dl = l !== 'dataLayer' ? `&l=${l}` : '';
    //@ts-ignore
    j.async = true;
    //@ts-ignore
    j.src = `${baseURL}?id=${i}${dl}`;
    //@ts-ignore
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', gtmId);
}

function addGTMNoScript(gtmId: string, baseURL: string) {
  const iframe = document.createElement('iframe');
  iframe.src = `${baseURL}?id=${gtmId}`;
  iframe.height = '0';
  iframe.width = '0';
  iframe.style.display = 'none';
  iframe.style.visibility = 'hidden';
  const noscript = document.createElement('noscript');
  noscript.appendChild(iframe);
  document.body.insertBefore(noscript, document.body.firstChild);
}
